module.exports = __webpack_public_path__ + "static/media/7.bd46fd72.jpg";